<template>
    <div class="text-white bg-danger-gradient box border-radius-6">
        <div class="box-pads inside">
            <div class="tile">
                <div class="icon-tile">
                    <i class="fa-solid fa-chalkboard-user"></i>
                </div>
                <div class="count-tile-description course-info">
                    <div class="count-tile-numbers">
                        {{ updateCourses.allCoursesCount }}
                    </div>
                    {{ sufixCourse }}
                </div>
            </div>
            <div class="tile-box">
                {{ $t('[[[w tym ]]]') }}
                {{ updateCourses.allCoursesPublishedCount }}
                {{ $t('[[[ opublikowanych]]]') }}
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import DashboardService, { CoursesCountModel } from '../../services/DashboardService';
import { useHomeStore } from '../../store/index';

@Options({
    name: 'all-courses',
})
export default class AllCourses extends Vue
{
    public store = useHomeStore();
    public countCourses: CoursesCountModel = {
        allCoursesCount: 0,
        allCoursesPublishedCount: 0,
        allCoursesInCurrentMonthCount: 0,
        newCoursesPublishedInCurrentMonthCount: 0,
        newCoursesUnpublishedInCurrentMonthCount: 0
    };
    public sufixCourse: string = '';

    public get updateCourses(): CoursesCountModel
    {
        if (this.countCourses.allCoursesCount == 1)
            this.sufixCourse = this.$t('[[[Szkolenie]]]');
        else if (this.countCourses.allCoursesCount < 5 && this.countCourses.allCoursesCount > 0)
            this.sufixCourse = this.$t('[[[Szkolenia]]]');
        else
            this.sufixCourse = this.$t('[[[Szkoleń]]]');

        return this.countCourses;
    }

    public async mounted(): Promise<void>
    {
        await this.loadData();
    }

    public async loadData(): Promise<void>
    {
        try
        {
            this.countCourses = await DashboardService.getCoursesCounters();
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.$alert.warning(ex.message)
            });
        }
    }
}
</script>

<style scoped lang="scss">
.border-radius-6 {
    border-radius: 6px;
}

.count-tile-description {
    font-size: 1.25rem;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 787px) and (max-width: 1550px) {
        font-size: .8125rem;
        align-items: center;
    }

    &.course-info {
        flex-direction: row;
        align-items: center;
        gap: .5rem;
        flex-wrap: wrap;

        @media screen and (min-width: 787px) and (max-width: 1550px) {
            flex-direction: column;
            gap: 0;
        }
    }
}

.count-tile-numbers {
    font-size: 34px;
    line-height: 1;
}

.tile {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: nowrap;

    @media screen and (min-width: 787px) and (max-width: 1550px) {
        flex-direction: column;
        gap: 8px;
    }
}

.box-pads {
    padding: 25px 15px;

    @media screen and (min-width: 787px) and (max-width: 1550px) {
        padding: 8px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        width: 100%;
    }
}

.tile-box {
    display: flex;
    align-items: center;
    font-size: .9375rem;

    @media screen and (min-width: 787px) and (max-width: 1550px) {
        text-align: center;
    }
}

.icon-tile {
    font-size: 1.875rem;
    color: #fff;
}

.box {
    height: 100%;
    display: flex;
}

.inside {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
